<!-- Render CLI Config recursively if present -->
<div *ngIf="obj.cliConfig">
  <ng-container *ngTemplateOutlet="cliConfigRecursive; context: { $implicit: obj.cliConfig, level: 0 }"></ng-container>
</div>

<ng-template #cliConfigRecursive let-config let-level="level">
  <ng-container *ngIf="config && config.length">
    <div *ngFor="let item of config; trackBy: trackByFn">
      <div [style.marginLeft.px]="(level + 1) * 20">
        <div class="object-item">
          <!-- Expand/Collapse Button -->
          <div 
            *ngIf="item.children && item.children.length > 0"
            (click)="toggleExpanded(item)"
            class="expand-collapse"
            [title]="isExpanded(item) ? 'Collapse' : 'Expand'">
            <img 
              src="../../../assets/icon_arrow_down.svg" 
              alt="arrow"
              class="arrow-icon"
              [class.rotated]="!isExpanded(item)"
            />
          </div>
          
          <!-- Spacer for items without children -->
          <span *ngIf="!item.children || item.children.length === 0" style="width: 20px; display: inline-block;"></span>
          
          <div class="object-details">
            <div class="object-type">{{ item.type | uppercase }}:</div>
            <div class="object-value">{{ item.value }}</div>
            <div *ngIf="item.parent" class="parent-name"> (Parent: {{ item.parent }})</div>
            <div *ngIf="item.children && item.children.length > 0" class="child-count">
              ({{ item.children.length }} child{{ item.children.length > 1 ? 'ren' : '' }})
            </div>
          </div>
        </div>
        
        <!-- Children (only show if expanded) -->
        <ng-container *ngIf="item.children && item.children.length && isExpanded(item)">
          <ng-container *ngTemplateOutlet="cliConfigRecursive; context: { $implicit: item.children, level: level + 1 }"></ng-container>
        </ng-container>
      </div>
    </div>
  </ng-container>
</ng-template>